import React, { useState } from "react";
import { Tabs, Tab, Box, IconButton, Typography } from "@mui/material";
import { Close } from "@mui/icons-material";
import AllDrugs from "./AllDrugs";
import AddDrug from "./AddDrug";
import DrugDetails from "./DrugDetails";

const DrugTabs = () => {
  const [tabs, setTabs] = useState([{ label: "All Drugs", component: "allDrugs" },{ label: "+ Add Drugs", component: "addDrugs" }]);
  const [selectedTab, setSelectedTab] = useState(0);

  // Function to Add a New Warehouse Tab
  const handleAddTab = (drug) => {
    const existingTab = tabs.find((tab) => tab.id === drug.drug_id);
    if (!existingTab) {
      setTabs([...tabs, { id: drug.drug_id, label: drug.name, component: "drugsDetails", data: drug }]);
      setSelectedTab(tabs.length);
    } else {
      setSelectedTab(tabs.findIndex((tab) => tab.id === drug.drug_id));
    }
  };

  // Function to Remove a Tab
  const handleCloseTab = (index) => {
    const newTabs = tabs.filter((_, i) => i !== index);
    setTabs(newTabs);
    setSelectedTab(index === selectedTab ? Math.max(0, index - 1) : selectedTab);
  };

  return (
    <Box sx={{ width: "100%" }}>
      {/* MUI Tabs */}
      <Tabs value={selectedTab} onChange={(e, newValue) => setSelectedTab(newValue)} variant="scrollable" scrollButtons="auto">
        {tabs.map((tab, index) => (
          <Tab
            key={index}
            label={
              <Box sx={{ display: "flex", alignItems: "center" }}>
                <Typography>{tab.label}</Typography>
                {index > 1 && (
                  <IconButton size="small" onClick={() => handleCloseTab(index)} sx={{ ml: 1 }}>
                    <Close fontSize="small" />
                  </IconButton>
                )}
              </Box>
            }
          />
        ))}
      </Tabs>

      {/* Tab Content */}
      <Box sx={{ p: 2 }}>
        {tabs[selectedTab].component === "allDrugs" && <AllDrugs onDrugClick={handleAddTab} />}
        {tabs[selectedTab].component === "addDrugs" && <AddDrug />}
        {tabs[selectedTab].component === "drugsDetails" && <DrugDetails warehouse={tabs[selectedTab].data} />}
      </Box>
    </Box>
  );
};

export default DrugTabs;
